import React from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'

const FacultyModal = ({ show, onHide, faculty }) => {
  const name = faculty?.name
  const title = faculty?.title
  const description = faculty?.description
  return (
    <Modal show={show} size='lg' onHide={onHide} centered>
      <Modal.Header className='border-0 pb-0 px-4 d-block'>
        <h3 className='font-heading sub-title-3 text-rich-navy mb-2'>{name}</h3>
        <p className='text-gold-light mb-2 fw-medium small font-paragraph small-paragraph'>
          {title}
        </p>
      </Modal.Header>
      <Modal.Body className='pb-3 pt-2 px-4'>
        {description && (
          <div style={{ whiteSpace: 'pre-line' }}>
            <p>{description}</p>
          </div>
        )}

        <div className='text-right mt-3 space-x-3'>
          <Button
            variant='secondary-light'
            size='sm'
            onClick={onHide}
            className='px-3'>
            Close
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default FacultyModal
